import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Well } from 'src/app/interfaces/well';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-general',
  templateUrl: './handover-detail-general.component.html',
  styleUrls: ['./handover-detail-general.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailGeneralComponent implements OnInit {
  well: Well | undefined;
  @Input() handoverId: number | undefined;
  @Input() wellUwi: string | undefined;

  constructor(private handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellUwi) {
      this.getHandoverDetailGeneral(
        this.handoverId as number,
        this.wellUwi as string
      );
    }
  }

  getHandoverDetailGeneral(handoverId: number, wellUwi: string): void {
    this.handoverService
      .getHandoverDetailGeneral(handoverId, wellUwi)
      .subscribe((wellData) => (this.well = wellData));
  }
}
